import { GenericRequestBody, GenericResponse } from '@omnea-digital/toolbox'
import createClient from 'openapi-fetch'
import { withErrorCapture } from '@omnea-app/packages/universal/general/observability/withErrorCapture'
import { ServiceUrls } from '@omnea-app/packages/universal/general/serviceUrls'
import { paths } from './assessmentsGeneratedTypes'

export class AssessmentsHttpClient {
  GET
  POST
  constructor({ authorization }: { authorization: string }) {
    const { GET, POST } = createClient<paths>({ baseUrl: ServiceUrls.ASSESSMENTS, headers: { Authorization: authorization } })
    this.GET = withErrorCapture({ method: GET })
    this.POST = withErrorCapture({ method: POST })
  }
}

export type AssessmentsResponse<T extends keyof paths, T2 extends keyof paths[T]> = GenericResponse<paths, T, T2>
export type AssessmentsRequestBody<T extends keyof paths, T2 extends keyof paths[T]> = GenericRequestBody<paths, T, T2>
export * from './assessmentsGeneratedTypes'
